const state = () => ({
  loading: false
});

const mutations = {
  setLoading(state, payload) {
    state.loading = payload;
  }
};

export const rsAssistant = {
  state,
  mutations,
  namespaced: true
};
